import { defineMessages } from 'react-intl';

export default defineMessages({
    noAPIKey: {
        id: 'platform.components.captcha.No API key set',
        defaultMessage: 'No API key set',
    },
});